import { apiClient } from 'utils/api';

export type TutorialName = 'agent-dashboard' | 'extra-touch';
export type TutorialStatus = 'completed' | 'dismissed';

export interface TutorialState {
  version: number;
  completedAt: string | null;
  dismissedAt: string | null;
}

export const fetchTutorial = async (name: TutorialName, signal?: AbortSignal): Promise<TutorialState> => {
  const { data } = await apiClient.get<TutorialState>(`/users/tutorials/${encodeURIComponent(name)}`, { signal });
  return data;
};

export const saveTutorial = async (name: TutorialName, status: TutorialStatus, signal?: AbortSignal): Promise<TutorialState> => {
  const { data } = await apiClient.patch<TutorialState>(`/users/tutorials/${encodeURIComponent(name)}`, { version: 1, status }, { signal });
  return data;
};
